/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_Aware_HelpInputs */

const en_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame gap will be calculated using shot change markers`)
};

const fr_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’écart sera calculé à partir des marqueurs de changement de plan`)
};

const de_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Frame-Lücke wird anhand der Shot-Wechsel-Markierungen berechnet.`)
};

const it_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intervallo di frame verrà calcolato utilizzando i marcatori di cambio di inquadratura`)
};

const ru_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разница между кадрами будет рассчитываться с помощью маркеров смены кадра.`)
};

const es_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La brecha de cuadro se calculará utilizando marcadores de cambio de tiro`)
};

const zh_cn2_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将使用投篮变化标记来计算帧间隙。`)
};

const ja_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレームギャップはショットチェンジマーカーを使用して計算されます`)
};

const hi_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन मार्करों का उपयोग करके फ्रेम अंतराल की गणना की जाएगी।`)
};

const pt_pt2_shot_change_aware_help = /** @type {(inputs: Shot_Change_Aware_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O intervalo entre frames será calculado usando marcadores de mudança de enquadramento.`)
};

/**
* | output |
* | --- |
* | "Frame gap will be calculated using shot change markers" |
*
* @param {Shot_Change_Aware_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_aware_help = /** @type {((inputs?: Shot_Change_Aware_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_Aware_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shot_change_aware_help(inputs)
	if (locale === "de") return de_shot_change_aware_help(inputs)
	if (locale === "it") return it_shot_change_aware_help(inputs)
	if (locale === "ru") return ru_shot_change_aware_help(inputs)
	if (locale === "es") return es_shot_change_aware_help(inputs)
	if (locale === "zh-CN") return zh_cn2_shot_change_aware_help(inputs)
	if (locale === "ja") return ja_shot_change_aware_help(inputs)
	if (locale === "hi") return hi_shot_change_aware_help(inputs)
	if (locale === "pt-PT") return pt_pt2_shot_change_aware_help(inputs)
	return en_shot_change_aware_help(inputs)
});